import React from 'react';
import { useSelector } from 'react-redux';

import ActivityWrapper from '../activity-wrapper/activity-wrapper';
import NoteSection from '../note-section';
import updateActivityShape from '../../../../../shapes/status-update-activity';
import { formatUsername } from '../../../../../utils/common';
import { MODE_TYPES } from '../../../../../constants';

/**
 * Status Updated Activity Component
 * @param {object} params - Object containing props
 * @param {object} params.activity - Activity to display
 * @return {element} - Activity Status Updated Component
 */
const ActivityStatusUpdated = ({ activity }) => {
  const hasLocation = activity.driverCity && activity.driverCity !== '';
  const hasResolvedProblems = activity.resolvedProblems && activity.resolvedProblems.length !== 0;
  const hasCheckIn = activity.checkInTime;
  const hasCheckOut = activity.checkOutTime;
  const modeType = useSelector((state) => state.modeType?.type);
  /**
   * Formats the driver location label
   * @return {string} - Driver location label
   */
  const formatDriverLocationLabel = () => {
    if (hasCheckIn) {
      return 'Check In Location';
    }
    if (hasCheckOut) {
      return 'Check Out Location';
    }
    return 'Driver Location';
  };

  // Build header content
  const headerContent = [{
    text: `${formatUsername(activity.initiatorName)} updated the status`, descriptor: modeType === MODE_TYPES.lessThanTruckload ? activity.newLTLStatus : activity.newTLStatus,
  }];
  if (hasLocation) {
    headerContent.push({ text: formatDriverLocationLabel(), descriptor: `${activity.driverCity}, ${activity.driverState}` });
  }
  if (hasResolvedProblems) {
    headerContent.push({ text: 'Problems', descriptor: activity.resolvedProblems.join(', ') });
  }

  return (
    <ActivityWrapper
      type={modeType === MODE_TYPES.lessThanTruckload ? activity.newLTLStatus : activity.newTLStatus}
      headerContent={headerContent}
      timestamp={activity.eventTime}
      testId="activity-update-status"
    >
      <NoteSection note={activity.note} />
    </ActivityWrapper>
  );
};

ActivityStatusUpdated.propTypes = {
  activity: updateActivityShape.isRequired,
};

export default ActivityStatusUpdated;
